import ResponseTargetingStepComponentRouterView from './responseTargetingStepComponentRouterView.html';
import '../responseTargetingStepComponent.scss';
import { StateViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/StateViewModel';
import { State } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/State';
import { ActiveMessagesConstants } from '../../../ActiveMessagesConstants';
import { RedirectType } from '../../../models/RedirectType';
import { ResponseTargetingStepComponentBase } from '../responseTargetingStepComponentBase';
import { CampaignType } from '../../../models/CampaignType';
export class ResponseTargetingRouterStepComponentController extends ResponseTargetingStepComponentBase {
    static $inject = ['ActiveMessageService', 'ContextProcessorService', 'LoadingService', 'BuilderService', 'HostingService', 'ApplicationService2', 'BlipToastService', 'GrowthSegmentService', '$translate', 'AlertService', '$scope'];
    constructor(ActiveMessageService, ContextProcessorService, LoadingService, BuilderService, HostingService, ApplicationService2, BlipToastService, GrowthSegmentService, $translate, AlertService, $scope) {
        'ngInject';
        super(ActiveMessageService, ContextProcessorService, LoadingService, BuilderService, HostingService, ApplicationService2, BlipToastService, GrowthSegmentService, $translate, AlertService);
        this.ActiveMessageService = ActiveMessageService;
        this.ContextProcessorService = ContextProcessorService;
        this.LoadingService = LoadingService;
        this.BuilderService = BuilderService;
        this.HostingService = HostingService;
        this.ApplicationService2 = ApplicationService2;
        this.BlipToastService = BlipToastService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.$scope = $scope;
        this.isWhatsAppGroup = false;
        this.isAiAgent = false;
        this.onSelectedAudience = async (event, data) => {
            await this.getChildrenWithStates();
        };
        this.onSelectChatbotOption = async (event) => {
            this.selectedChildChatbot = event.detail?.value;
            this.stateId = undefined;
            if (!this.selectedChildChatbot) {
                this.statesBotMaster = undefined;
                this.isDeskIdInStateFlow = true;
                this.validTargeting = false;
            }
            else {
                this.statesBotMaster = [];
                await this.loadChildrenStates();
                if (this.isAttendanceRedirect == RedirectType.Agent) {
                    this.isDeskIdInStateFlow = await this.checkIfDeskIdIsInStateFlow(this.statesBotMaster);
                    if (this.isDeskIdInStateFlow) {
                        this.validTargeting = true;
                    }
                    else {
                        this.validTargeting = false;
                    }
                }
                else {
                    this.validTargeting = true;
                }
            }
        };
        this.changeTarget = async (event) => {
            this.changeTargetParent(event.detail?.value);
            this.trackSelectedFlow(ActiveMessagesConstants.MASTER);
        };
        this.getLabelBotState = async () => {
            return this.labelBotState;
        };
        this.checkIfRedirectIsAllowed = () => {
            if (this.checkIfRedirectIsAllowedBase()) {
                return true;
            }
            if (this.campaignType == CampaignType.Batch && this.isAttendanceRedirect == RedirectType.Agent) {
                this.setRedirectType(RedirectType.Flow);
            }
            return false;
        };
        this.setRedirectType = async (value) => {
            await this.setRedirectTypeParent(value);
            this.validTargeting = false;
            this.selectedChildChatbot = undefined;
            this.stateDataOptions = this.generateStatesDataOptions(this.statesBotMaster);
        };
        this.onChangeRedirectType = async (event) => {
            if (event.detail?.checked) {
                const target = event.target;
                await this.setRedirectType(target?.id);
            }
        };
        this.getData = () => {
            return {
                name: this.stepName,
                value: [],
                params: {
                    stateId: this.stateId,
                    template: this.application.template,
                    flowId: this.flowId,
                    masterState: this.selectedChildIdentity,
                    attendanceRedirect: undefined,
                },
            };
        };
        this.getState = () => this.statesBotMaster.find((x) => x.id === this.stateId);
        this.checkContinueButtonRouter = () => this.isWhatsAppGroup || this.isAiAgent || (this.isDeskIdInStateFlow && this.checkContinueButton() && this.validTargeting);
        this.statesBotMaster = [];
        this.allChildrenToChoose = [];
        this.$scope.$on('$onSelectedAudience', this.onSelectedAudience);
    }
    async $onInit() {
        await this.initialize();
        this.labelBotState = await this.$translateParent('activeMessages.send.responseTargeting.select.labelState');
    }
    async getChildrenWithStates() {
        const filteredChildren = [];
        this.stateId = '';
        const childrenFromApplication = await this.ApplicationService2Parent.getApplicationsWithChildren(this.application.shortName, this.application.tenantId);
        if (this.isAiAgent) {
            await Promise.all(childrenFromApplication.map(async (c, i) => {
                try {
                    if (c?.template == 'aiAgent') {
                        filteredChildren.push({ value: c.shortName, label: c.name, data: undefined, template: c.template });
                    }
                }
                catch (e) {
                    console.error(e);
                }
                return c;
            }));
        }
        else {
            await Promise.all(childrenFromApplication.map(async (c, i) => {
                try {
                    if (c?.template == 'builder') {
                        const statesList = await this.ActiveMessageServiceParent.listStates(c.shortName, true);
                        filteredChildren.push({ value: c.shortName, label: c.name, data: statesList, template: c.template });
                    }
                }
                catch (e) {
                    console.error(e);
                }
                return c;
            }));
        }
        this.allChildrenToChoose = filteredChildren;
    }
    getStateDataOptions() {
        return this.generateStatesDataOptions(this.statesBotMaster);
    }
    $onChanges(changesObj) {
        if (changesObj.states && !changesObj.states.isFirstChange()) {
            this.stateDataOptions = this.generateStatesDataOptions(this.statesBotMaster);
        }
    }
    async loadChildrenStates() {
        try {
            this.selectedChildIdentity = `${this.selectedChildChatbot}${ActiveMessagesConstants.MSGING_SUFFIX}`;
            const childrenData = this.allChildrenToChoose.find(child => child.value == this.selectedChildChatbot);
            if (childrenData.template !== 'aiAgent') {
                this.flowId = await this.ActiveMessageServiceParent.getFlowId(this.selectedChildChatbot);
                const flows = childrenData.data.items;
                await Promise.all(flows.forEach(flow => {
                    const converted = this.convertStateItem(flow);
                    const state = new State(converted);
                    const stateViewModel = StateViewModel.create(state);
                    stateViewModel.$title = state.name;
                    this.statesBotMaster.push(stateViewModel);
                }));
                this.stateDataOptions = this.generateStatesDataOptions(this.statesBotMaster);
            }
        }
        catch (error) {
            this.validTargeting = false;
            this.stateDataOptions = [];
            this.BlipToastServiceParent.show('danger', {
                msg: this.errorLoadStatesDescription,
            });
        }
    }
}
ResponseTargetingRouterStepComponentController.$inject = ['ActiveMessageService', 'ContextProcessorService', 'LoadingService', 'BuilderService', 'HostingService', 'ApplicationService2', 'BlipToastService', 'GrowthSegmentService', '$translate', 'AlertService', '$scope'];
export const ResponseTargetingRouterStep = {
    template: ResponseTargetingStepComponentRouterView,
    controller: ResponseTargetingRouterStepComponentController,
    controllerAs: '$ctrl',
    bindings: {
        step: '@?',
        parent: '@?',
        next: '&?',
        previous: '&?',
        callback: '&?',
        campaignType: '@?',
        isBotRouter: '@?',
        isBotAiAgent: '@?',
        errorAttendance: '@?',
        isWhatsAppGroup: '<?',
    },
};
